import { GridBox, Image, SpacerWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledGridBox = styled(GridBox)`
  padding: 2rem;
`;

export const OuterContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    display: grid;
    grid-template-columns: 1fr 6fr;
  }
`;

export const Container = styled(SpacerWrapper)`
  display: flex;
  max-width: 50rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  grid-column-start: 2;
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    flex-direction: row;
  }
`;

export const FlexContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledImage = styled(Image)`
  width: 73px;
  height: 35px;
  @media (min-width: ${({ theme }) => theme.media.xs}) {
    width: 97px;
    height: 46px;
  }
`;
